var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18441 12.186C6.16951 12.186 5.9577 12.3949 5.9577 13.3953V15.2094C5.9577 16.21 6.16951 16.4188 7.18441 16.4188H9.6378V23.6751C9.6378 24.6756 9.84961 24.8844 10.8645 24.8844H13.3179C14.3328 24.8844 14.5446 24.6756 14.5446 23.6751V16.4188H17.2994C18.0691 16.4188 18.2675 16.2713 18.4789 15.5417L19.0047 13.7276C19.3668 12.4778 19.1437 12.186 17.8251 12.186H14.5446V9.16259C14.5446 8.49467 15.0938 7.95321 15.7713 7.95321H19.2627C20.2775 7.95321 20.4894 7.74439 20.4894 6.74384V4.32509C20.4894 3.32454 20.2775 3.11572 19.2627 3.11572H15.7713C12.3838 3.11572 9.6378 5.823 9.6378 9.16259V12.186H7.18441Z",
    stroke: "white",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.964e24ac9c0e4a279775b4d92fabe4e8.svg";
export { ForwardRef as ReactComponent };